import { WarningCircleIcon } from '@phosphor-icons/react'

import * as S from './error-message.styled'

interface ErrorMessageProps {
  message?: string
}

export const ErrorMessage = ({ message }: ErrorMessageProps) => {
  if (!message) return null

  return (
    <S.ErrorMessage>
      <S.Icon icon={WarningCircleIcon} size="2rem" />
      <S.MessageText>{message}</S.MessageText>
    </S.ErrorMessage>
  )
}
